<div class="content-blk">
<div class="pricing-tags-container">
  <!-- Header -->
  <div class="page-header">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-content">
      <h2>{{ isEditMode ? 'Edit Product - Pricing & Tags' : 'Pricing & Tags' }}</h2>
      <p class="header-subtitle">{{ isEditMode ? 'Update pricing and tags for your product' : 'Set pricing and add tags for each product to help customers find them' }}</p>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-cards">
    <div class="summary-card">
      <div class="card-icon">
        <i class="fa fa-dollar"></i>
      </div>
      <div class="card-content">
        <label>Average Price</label>
        <h3>{{averagePrice | currency:'USD':'symbol':'1.2-2'}}</h3>
      </div>
    </div>

    <div class="summary-card">
      <div class="card-icon">
        <i class="fa fa-box"></i>
      </div>
      <div class="card-content">
        <label>Products</label>
        <h3>{{totalProducts}}</h3>
      </div>
    </div>

    <div class="summary-card">
      <div class="card-icon">
        <i class="fa fa-palette"></i>
      </div>
      <div class="card-content">
        <label>Total Variants</label>
        <h3>{{totalVariants}}</h3>
      </div>
    </div>

    <div class="summary-card">
      <div class="card-icon">
        <i class="fa fa-tags"></i>
      </div>
      <div class="card-content">
        <label>Unique Tags</label>
        <h3>{{uniqueTags.size}}</h3>
      </div>
    </div>
  </div>

  <!-- Global Pricing Adjustment -->
  <div class="global-pricing-section">
    <h3>Global Pricing Adjustment</h3>
    <p class="section-subtitle">Apply the same pricing adjustment to all products at once</p>
    <div class="global-pricing-controls">
      <mat-form-field class="type-select">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="globalProfitType">
          <!-- <mat-option value="percent">% Percent</mat-option> -->
          <mat-option value="dollar">$ Dollar</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="profit-input">
        <mat-label>Value</mat-label>
        <input matInput type="number" [(ngModel)]="globalProfitValue" min="0">
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="applyGlobalPricing()">
        Apply to All Products
      </button>
    </div>
  </div>

  <!-- Products List -->
  <div class="products-section">
    <h3>Product Pricing & Tags</h3>

    <div class="product-pricing-card" *ngFor="let product of products; trackBy: trackByProductId">
      <!-- Product Header -->
      <div class="product-pricing-header">
        <img [src]="product.productImage" alt="{{product.productName}}" class="product-thumb">
        <div class="product-info">
          <h4>{{product.productName}}</h4>
          <p class="product-meta">{{product.productCategory}} • {{product.colorCount}} color{{product.colorCount !== 1 ? 's' : ''}}</p>
        </div>
      </div>

      <!-- Title & Description Section -->
      <div class="title-description-section">
        <label class="field-label">Product Title</label>
        <input class="custom-input" [(ngModel)]="product.title" placeholder="Enter product title">

        <label class="field-label" style="margin-top: 14px;">Description</label>
        <angular-editor [(ngModel)]="product.description" [config]="editorConfig"></angular-editor>
      </div>

      <!-- Pricing Section -->
      <div class="pricing-section">
        <div class="pricing-row">
          <div class="price-field-compact">
            <label>Base Price</label>
            <div class="price-display-compact">${{product.basePrice.toFixed(2)}}</div>
          </div>

          <div class="price-field-compact">
            <label>Retail Price</label>
            <div class="price-display-compact retail">${{product.retailPrice.toFixed(2)}}</div>
            <div *ngIf="product.designedSideCount > 1" style="font-size: 11px; color: #6b7280; margin-top: 2px;">
              incl. +${{ getExtraSideCost(product).toFixed(2) }} for {{ product.designedSideCount }} decoration locations
            </div>
          </div>

          <div class="pricing-adjustment">
            <label>Pricing Adjustment</label>
            <div class="adjustment-controls">
              <mat-form-field class="type-select-small">
                <mat-select [(ngModel)]="product.profitType" (ngModelChange)="onProfitTypeChange(product)">
                  <!-- <mat-option value="percent">%</mat-option> -->
                  <mat-option value="dollar">$</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="value-input">
                <input matInput type="number" [(ngModel)]="product.profitValue"
                       (ngModelChange)="onProfitValueChange(product)" min="0">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Tags Section -->
      <div class="tags-section">
        <label class="tags-label">Add tags...</label>

        <!-- Custom Tag Input -->
        <div class="custom-tag-input">
          <mat-form-field class="tag-text-field">
            <mat-label>Enter custom tag</mat-label>
            <input
              matInput
              [(ngModel)]="customTagInputs[product.productId]"
              (keypress)="onCustomTagKeyPress($event, product)"
              placeholder="Type and press Enter">
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            class="add-tag-btn"
            [disabled]="!hasCustomTagInput(product)"
            (click)="addCustomTag(product)">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <!-- Selected Tags -->
        <div class="selected-tags" *ngIf="product.tags.length > 0">
          <div class="tag-chip" *ngFor="let tag of product.tags"
               [class.default-tag]="tag === product.productCategory">
            {{tag}}
            <button mat-icon-button class="tag-remove"
                    *ngIf="tag !== product.productCategory"
                    (click)="removeTag(product, tag)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- Suggested Tags -->
        <div class="suggested-tags">
          <button
            mat-stroked-button
            class="tag-suggestion"
            *ngFor="let tag of suggestedTags"
            [disabled]="product.tags.includes(tag)"
            (click)="addTag(product, tag)">
            <i class="fa fa-plus"></i> {{tag}}
          </button>
        </div>
      </div>

      <!-- Product Labels Section -->
      <div class="labels-section">
        <label class="labels-title">Product Labels</label>

        <div class="label-row" *ngFor="let label of product.labels; let i = index">
          <div class="label-input-wrapper">
            <label class="field-label-sm">Label Text</label>
            <input class="custom-input-sm" [(ngModel)]="label.text" placeholder="e.g. Sale, New">
          </div>

          <!-- Live Preview -->
          <div class="label-preview-block"
               [style.background]="label.backgroundColor"
               [style.color]="label.textColor">
            {{label.text || 'Preview'}}
          </div>

          <!-- Background Color Picker -->
          <div class="color-picker-inline">
            <label>BG</label>
            <input type="color"
                   [value]="label.backgroundColor"
                   (input)="label.backgroundColor = $any($event.target).value"
                   class="native-color-input">
          </div>

          <!-- Text Color Picker -->
          <div class="color-picker-inline">
            <label>TEXT</label>
            <input type="color"
                   [value]="label.textColor"
                   (input)="label.textColor = $any($event.target).value"
                   class="native-color-input">
          </div>

          <button mat-icon-button color="warn" (click)="removeLabel(product, i)" class="remove-label-btn">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <button mat-stroked-button color="primary" (click)="addLabel(product)" class="add-label-btn">
          <mat-icon>add</mat-icon> Add Label
        </button>
      </div>

    </div>
  </div>

  <!-- Footer Actions -->
  <div class="footer-actions">
    <div class="footer-summary">
      <p>Ready to publish <strong>{{totalProducts}}</strong> product{{totalProducts !== 1 ? 's' : ''}} with <strong>{{totalVariants}}</strong> variant{{totalVariants !== 1 ? 's' : ''}}</p>
      <p class="tags-info" *ngIf="uniqueTags.size === 0"><i class="fa fa-exclamation-triangle"></i> No tags added</p>
    </div>
    <div class="footer-buttons">
      <button mat-stroked-button (click)="goBack()" class="btn-secondary">
        <mat-icon>arrow_back</mat-icon>
        Back to Color Selection
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="publishProducts()"
        class="btn-publish">
        {{ isEditMode ? 'Update Product' : 'Publish Products' }}
        <mat-icon>{{ isEditMode ? 'save' : 'rocket_launch' }}</mat-icon>
      </button>
    </div>
  </div>
</div>
</div>

<!-- Store Selection Dialog Template (store-admin flow) -->
<ng-template #storeSelectionDialog>
  <div class="store-selection-dialog-content">
    <h2>Select Store</h2>
    <p class="dialog-subtitle">Choose which store to publish this product to</p>

    <mat-radio-group [(ngModel)]="selectedPublishStoreId">
      <div class="store-grid">
        <div *ngFor="let store of storeList"
             class="store-grid-item"
             [class.selected]="selectedPublishStoreId === store.StoreId"
             (click)="onStoreSelected(store.StoreId); selectedPublishStoreId = store.StoreId">
          <mat-radio-button [value]="store.StoreId" class="store-radio-hidden">
          </mat-radio-button>
          <div class="store-icon-wrap">
            <svg width="40" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <g><g><path d="M488.468,448.903h-8.532V226.4C499.202,214.003,512,192.386,512,167.822c0-1.305-0.341-2.588-0.988-3.721L451.499,59.953 c-4.18-7.313-12.009-11.857-20.432-11.857H80.933c-8.423,0-16.252,4.543-20.432,11.857L0.988,164.101 C0.341,165.234,0,166.518,0,167.822c0,24.564,12.798,46.181,32.064,58.578v222.503h-8.532c-4.142,0-7.5,3.358-7.5,7.5 c0,4.142,3.358,7.5,7.5,7.5h464.936c4.143,0,7.5-3.358,7.5-7.5C495.968,452.261,492.61,448.903,488.468,448.903z M15.517,175.322 h24.044c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H20.424l53.101-92.927c1.516-2.652,4.354-4.299,7.408-4.299h350.134 c3.054,0,5.893,1.647,7.408,4.299l53.1,92.927h-19.141c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h24.048 c-3.667,26.584-26.532,47.125-54.108,47.125c-27.575,0-50.429-20.543-54.097-47.125h52.096c4.143,0,7.5-3.358,7.5-7.5 c0-4.142-3.357-7.5-7.5-7.5H71.631c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h52.091 c-3.668,26.582-26.523,47.125-54.097,47.125C42.049,222.447,19.184,201.906,15.517,175.322z M372.222,175.322 c-3.668,26.582-26.523,47.125-54.097,47.125c-27.575,0-50.429-20.543-54.097-47.125H372.222z M247.972,175.322 c-3.668,26.582-26.523,47.125-54.097,47.125c-27.574,0-50.429-20.543-54.097-47.125H247.972z M424.854,448.904h-81.193v-25.081 h81.193V448.904z M424.854,408.823h-81.193V271.516h81.193V408.823z M464.936,448.904h-25.081V264.016c0-4.142-3.357-7.5-7.5-7.5 h-96.193c-4.143,0-7.5,3.358-7.5,7.5v184.887H47.064V233.674c7.081,2.433,14.665,3.773,22.561,3.773 c27.095,0,50.624-15.556,62.125-38.207c11.501,22.65,35.03,38.207,62.125,38.207c27.095,0,50.624-15.556,62.125-38.207 c11.501,22.65,35.03,38.207,62.125,38.207c27.095,0,50.624-15.556,62.125-38.207c11.501,22.65,35.03,38.207,62.125,38.207 c7.896,0,15.48-1.34,22.561-3.772V448.904z"/></g></g>
              <g><g><path d="M296.081,256.516H79.645c-4.142,0-7.5,3.358-7.5,7.5v152.307c0,4.142,3.358,7.5,7.5,7.5h216.436 c4.143,0,7.5-3.358,7.5-7.5V264.016C303.581,259.873,300.224,256.516,296.081,256.516z M288.581,408.823H87.145V271.516h201.436 V408.823z"/></g></g>
            </svg>
          </div>
          <span class="store-grid-name">{{store.StoreName}}</span>
        </div>
      </div>
    </mat-radio-group>

    <div class="store-dialog-actions">
      <button mat-stroked-button (click)="dialog.closeAll()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!selectedPublishStoreId" (click)="confirmStoreSelection()">
        Publish to Selected Store
      </button>
    </div>
  </div>
</ng-template>

<!-- Success Dialog Template -->
<ng-template #successDialog>
  <div class="success-dialog-content">
    <div class="success-icon">
      <mat-icon>check_circle</mat-icon>
    </div>
    <h2>{{ isEditMode ? 'Updated!' : 'Published!' }}</h2>
    <p>{{ isEditMode ? 'Product has been updated to Shopify successfully!' : 'Product has been published to Shopify successfully!' }}</p>
    <button mat-raised-button color="primary" (click)="closeSuccessDialog()">
      Go to Products
    </button>
  </div>
</ng-template>
